export default {
  sendAllPaymentReminderMail(invoices) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/crms/payment-reminder/send-all/`, { invoices });
  },
  getInvoicePaymentReminderMailPreview(invoices) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/crms/payment-reminder/preview/`, { invoices });
  },
};
